"use client";
import React from "react";
import { Link } from "@/i18n/navigation";
import { MainData } from "@/components/common/CommonArray/FileArray";
import styles from "./home.module.css";
import { useTranslations } from "next-intl";

const featuredToolSlugs = [
  "/word-counter",
  "/bmi-calculator",
  "/age-calculator",
  "/currency-convertor",
  "/image-compressor",
  "/qr-code-generator",
  "/password-generator",
  "/text-case-inverter",
];

export default function FeaturedTools() {
  const t = useTranslations("home");
  const featuredTools = MainData.filter((tool) =>
    featuredToolSlugs.includes(tool.navigate)
  );

  return (
    <section className={styles.featuredSection}>
      <div className="container-md">
        <h2 className={styles.sectionTitle}>{t("featuredToolsTitle")}</h2>
        <p className={styles.sectionDescription}>
          {t("featuredToolsDescription")}
        </p>
        <div className={styles.featuredGrid}>
          {featuredTools.map((tool) => (
            <Link
              href={tool.navigate}
              key={tool.navigate}
              className={styles.featuredCard}
            >
              <div className={styles.cardIcon}>
                <div className={styles.iconBox} />
              </div>
              <h3 className={styles.cardTitle}>{tool.Name}</h3>
              <p className={styles.cardDescription}>
                {tool.description ||
                  `Powerful ${tool.Name.toLowerCase()} tool for your daily needs.`}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
